import * as React from 'react';
import { IconType } from 'react-icons';
import { merge } from '../../helpers/Utility';
import { withField } from './withField';

interface InjectedProps {
  value: string;
  onChange: (v: string) => void;
}

interface TextInputProps {
  name: string;
  placeholder?: string;
  autoComplete?: string;
  type?: string;
  Icon?: IconType;
  className?: string;
}

export const TextInput: React.FC<TextInputProps & InjectedProps> = ({
  className,
  name,
  onChange,
  value,
  placeholder,
  Icon,
  type = 'text',
  ...props
}) => {
  return (
    <div className="mt-1 flex rounded-md shadow-sm text-primary-std">
      {Icon ? (
        <span className="inline-flex items-center px-2 rounded-l-md border border-r-0 border-primary-std bg-gray-50 dark:bg-secondary-std">
          <Icon className="w-5 h-5" />
        </span>
      ) : null}
      <input
        {...props}
        type={type}
        name={name}
        id={name}
        className={merge(
          Icon ? 'rounded-r-md' : 'rounded-md',
          'focus:ring-primary-500 bg-primary-std focus:border-primary-500 flex-1 min-w-0 block w-full sm:text-sm border-primary-std',
          className
        )}
        placeholder={placeholder}
        value={value}
        onChange={event => onChange(event.target.value)}
      />
    </div>
  );
};

export const TextFieldWithOptionalLabel = withField(TextInput);
export const TextField = withField<string, TextInputProps>(TextInput);
